/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .media-center-photo[_ngcontent-%COMP%]{position:relative;height:146px;width:em(300);border-radius:7px;box-shadow:0 0 6px 0 rgba(0,0,0,.1)}[_nghost-%COMP%]   .media-center-photo-img[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;border-radius:inherit}"];
export { styles as styles };
